/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const ResendSetupMFAPasscode_Shared_Mutation = gql`
  mutation ResendSetupMFAPasscode_Shared_Mutation(
    $input: AuthUserTwoFactorAuthenticationResendEmailSetupInput!
  ) {
    auth {
      userResendEmailSetupTwoFactorAuthentication(input: $input) {
        sent
        errors {
          message
        }
      }
    }
  }
`;

export { ResendSetupMFAPasscode_Shared_Mutation };
